import { MenuItem } from "@/app/ui/navigation/types";
import { EnumFeatureFlag } from "@/app/services/generated/enums/enumFeatureFlag.generated";
import Guid from "@/app/types/common/guid";
import { RouteBuilder } from "@/app/ui/navigation/routeBuilder";
import { keys } from "@/plugins/i18n";

const builder = new RouteBuilder("Support_");

export const supportRoutes = {
  tools: builder.route({
    url: "/support/tools",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportTools.vue"
      ),
  }),
  customers: builder.route({
    url: "/support/customers",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportTenantGroupView.vue"
      ),
  }),
  stripe2Xero: builder.route({
    url: "/support/stripe2xero",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportStripeToXeroSync.vue"
      ),
  }),
  users: builder.routeWithParam(
    {
      url: "/support/customers/:id/users",
      view: (): Promise<any> =>
        import(
          /* webpackChunkName: "support" */ "@/components/pages/support/SupportTenantGroupUsersView.vue"
        ),
      componentProps: (route) => ({
        tenantGroupId: Guid.tryParse(route.params.id) ?? undefined,
      }),
    },
    (opts: { tenantGroupId: Guid }) => ({
      id: opts.tenantGroupId.value,
    })
  ),
  migrateAssemblies: builder.route({
    url: "/support/migrate-assemblies",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportMigrateAssembliesToMegaBatches.vue"
      ),
  }),
  orderCreditDutyUpdate: builder.route({
    url: "/support/order-credit-duty-update",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportOrderCreditDutyUpdate.vue"
      ),
  }),
  consumablesUpdate: builder.route({
    url: "/support/consumables-update",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportConsumables.vue"
      ),
  }),
  eprUpdate: builder.route({
    url: "/support/epr-update",
    view: (): Promise<any> =>
      import(
        /* webpackChunkName: "support" */ "@/components/pages/support/SupportEprUpdate.vue"
      ),
  }),
};

export const buildSupportMenuItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    translationKey: keys.brewman_support.value,
    icon: "SupportAgent",
    requiredFeatureFlag: EnumFeatureFlag.showSupportFunctions,
    subMenus: [
      MenuItem.forRoute("BrewMan Support Tools", supportRoutes.tools),
      MenuItem.forRoute("BrewMan Support Customers", supportRoutes.customers),
      MenuItem.forRoute("Stripe To Xero", supportRoutes.stripe2Xero),
      MenuItem.forRoute("Migrate Assemblies", supportRoutes.migrateAssemblies),
      MenuItem.forRoute(
        "Order Credit Duty Update",
        supportRoutes.orderCreditDutyUpdate
      ),
      MenuItem.forRoute("Consumables Update", supportRoutes.consumablesUpdate),
      MenuItem.forRoute("EPR Update", supportRoutes.eprUpdate),
    ],
  }),
];
